import React from 'react';
import { useLocation } from 'react-router-dom';

import FollowingArea from '../components/FollowingArea';
import Footer from '../components/Footer';
import Header from '../components/Header';
import OptionsArea from '../components/OptionsArea';
import UserMini from '../components/UserMini';

import './Search.css'

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

function Search() {
    const query = useQuery();
    const nome = query.get("name");

    return (
        <div className="container-search-page">
            <Header />
            <OptionsArea />
            <main>
                <div className="search-title">
                    <p>Você pesquisou</p>
                    <h1>{`"${nome}"`}</h1>
                </div>
                <div className="container-list-users">
                    <UserMini
                        id={1}
                        name="Lucia Campos"
                        url_avatar=""
                    />

                    <UserMini
                        id={1}
                        name="João Silva"
                        url_avatar=""
                    />
                </div>
            </main>
            <FollowingArea />
            <Footer />
        </div>
    )
}

export default Search;